import { createFileRoute, redirect } from '@tanstack/react-router';
import { adminNeedToLogin } from '@/features/login-admin/util';

export const Route = createFileRoute('/admin')({
    beforeLoad: async ({ location }) => {
        if (await adminNeedToLogin()) {
            if (location.pathname !== '/admin/auth/login') {
                throw redirect({ to: '/admin/auth/login' });
            }
        } else if (location.pathname === '/admin' || location.pathname === '/admin/auth/login') {
            throw redirect({ to: '/admin/empresa' });
        }
    },
});
